/* eslint-disable */
export default {
    maintenance_page_title: "The site is currently unavailable",
    maintenance_title: "Our platform is undergoing scheduled maintenance to enhance the performance and reliability of our services.",
    maintenance_description: "Our apologies and thank you for your patience.\nIf you have any questions, please contact the LTP help desk:\n\nEmail: online@ltp.nl\nTelephone: +31 20 30 50 438\n\nThe help desk is available on working days from 8.30 to 17.30 CET.",
    maintenance_notification_bar_text_a: "On",
    maintenance_notification_bar_text_b: "the platform will be temporarily unavailable. We apologize for any inconvenience this may cause and appreciate your understanding as we work to provide you with an even better experience."
};
